<div class="bgcomp h-100 pl-3 py-3 position-relative">
  <div
    id="dialog-header"
    mat-dialog-title
    class="drag-handle-header"
    cdkDrag
    cdkDragRootElement=".draggable-dialog-container.imaging-request-details-dialog"
    cdkDragBoundary=".cdk-overlay-container"
    cdkDragHandle
  >
    <h2>Request Details</h2>
    <div class="header-badges">
      @for(headerBadge of headerBadges; track headerBadge) {
      <p class="badge {{ headerBadge?.class }}">
        {{ headerBadge?.display?.toUpperCase() }}
      </p>
      }
    </div>

    <button mat-button mat-dialog-close id="close-icon">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <mat-dialog-content class="custom-scrollbar overflow-auto m-0 p-0">
    <div class="row no-gutters panel-row">
      <div class="col col-patient">
        <div id="section section-patient" class="section h-100">
          <h4 class="section-header dotted-underline">Patient</h4>
          <div class="row section-body d-flex">
            <div class="col label-and-value d-flex flex-column">
              <p class="label">Patient First Name</p>
              <p id="patient-first-name" class="label value">
                {{ imagingRequest?.patientFirstName }}
              </p>
            </div>
            <div class="col label-and-value d-flex flex-column">
              <p class="label">Patient Surname</p>
              <p id="patient-surname" class="label value">
                {{ imagingRequest?.patientLastName }}
              </p>
            </div>
            <div class="col label-and-value d-flex flex-column">
              <p class="label">Date of Birth</p>
              <p id="patient-dob" class="label value">
                {{ CommonUtilities.formatDateTime(imagingRequest?.patientDob) }}
              </p>
            </div>
            <div class="col label-and-value d-flex flex-column">
              <p class="label">Patient Location</p>
              <p id="patient-location" class="label value">
                {{ imagingRequest?.patientLocation }}
              </p>
            </div>
            <div class="col label-and-value d-flex flex-column">
              <p class="label">Hospital Number</p>
              <p id="hospital-number" class="label value">
                {{ imagingRequest?.patientMrn }}
              </p>
            </div>
            <div class="col label-and-value d-flex flex-column">
              <p class="label">Site Name</p>
              <p id="site-name" class="label value">
                {{ imagingRequest?.siteName }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="col col-requested-by">
        <div id="section section-requested-by" class="section h-100">
          <h4 class="section-header dotted-underline">Requested By</h4>
          <div class="row section-body">
            <div class="col label-and-value d-flex flex-column">
              <p class="label">Clinician Name</p>
              <p id="clinician-first-name" class="label value">
                {{ imagingRequest?.referringDoctor }}
              </p>
            </div>
            <div class="col label-and-value d-flex flex-column">
              <p class="label">Phone Number</p>
              <p id="clinician-phone" class="label value">
                {{ imagingRequest?.referringDoctorPhone }}
              </p>
            </div>
            <div class="col label-and-value d-flex flex-column">
              <p class="wide-label">Authority to Request Scans</p>
              <p id="request-scans-authority" class="label value">
                {{ authorityToRequestScans ? 'Yes' : 'No' }}
              </p>
            </div>
            @if(!authorityToRequestScans) {
            <div class="col label-and-value d-flex flex-column">
              <p class="label">Approved by</p>
              <p id="approved-by" class="label value">
                {{ approvedBy }}
              </p>
            </div>
            }
          </div>
        </div>
      </div>
    </div>
    <div class="row no-gutters panel-row">
      <div class="col col-medical-history">
        <div id="section section-patient-medical-history" class="section h-100">
          <div class="d-flex dotted-underline">
            <h4 class="section-header flex-grow-1">Patient Medical History</h4>
            <div
              id="contrast-allergy-text"
              class="info-pill"
              [ngClass]="contrastAllergyClass$ | async"
            >
              {{ contrastAllergyText$ | async }}
            </div>
            <div
              id="pregnancy-text"
              class="info-pill"
              [ngClass]="pregnancyClass$ | async"
            >
              {{ pregnancyText$ | async }}
            </div>
          </div>
          <div class="row section-body">
            <div class="col col-medical-notes">
              <div class="col label-and-value d-flex flex-column">
                <p class="label">Differential Diagnosis</p>
                <p id="differential-diagnosis" class="label value mb-3">
                  {{ differentialDiagnosis$ | async }}
                </p>
              </div>
              <div class="col label-and-value d-flex flex-column">
                <p class="label">Clinical History</p>
                <div id="clinical-history" class="label value">
                  <p
                    *ngFor="let clinicalHistory of clinicalHistories"
                    class="label value"
                  >
                    {{ clinicalHistory }}
                  </p>
                </div>
              </div>
            </div>
            <div class="col col-urgency">
              <div class="col label-and-value d-flex flex-column">
                <div class="label">Urgency Level</div>
                <div id="urgency-level" class="label value">
                  <mat-checkbox
                    id="polytrauma-status"
                    disabled="true"
                    [checked]="isTrauma"
                    >PolyTrauma
                  </mat-checkbox>
                  <div>
                    <mat-checkbox
                      id="stroke-status"
                      disabled="true"
                      [checked]="isStroke"
                      >Stroke
                    </mat-checkbox>
                    <div class="col">
                      <div>
                        <mat-checkbox
                          id="stroke-type-thrombectomy"
                          class="stroke-type-selection label"
                          disabled="true"
                          [checked]="imagingRequest?.isThrombectomy"
                          >Thrombectomy
                        </mat-checkbox>
                      </div>
                      <div>
                        <mat-checkbox
                          id="stroke-type-thrombolysis"
                          class="stroke-type-selection label"
                          disabled="true"
                          [checked]="imagingRequest?.isThrombolysis"
                          >Thrombolysis
                        </mat-checkbox>
                      </div>
                      <div>
                        <mat-checkbox
                          id="stroke-type-simple-stroke"
                          class="stroke-type-selection label"
                          disabled="true"
                          [checked]="imagingRequest?.isSimpleStroke"
                          >Simple Stroke
                        </mat-checkbox>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col col-egfr-paediatric-consult">
              <div class="ml-0 row">
                <div class="col label-and-value d-flex flex-column">
                  <p class="label">eGFR</p>
                  <p id="egfr" class="label value">
                    {{ (egfrKnown$ | async) ? 'Known' : 'Unknown' }}
                  </p>
                </div>
                @if(egfrKnown$ | async) {
                <div class="col label-and-value d-flex flex-column">
                  <p class="label">eGFR Result</p>
                  <p id="egfr-result" class="label value">
                    {{ egfrResult }}
                  </p>
                </div>
                }
                <div class="col label-and-value d-flex flex-column">
                  <div class="label">Paediatric Consultation Complete</div>
                  <div
                    id="paediatric-consultation-complete"
                    class="label value"
                  >
                    {{ paediatricConsultation$ | async }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col col-relevant-priors">
        <div id="section-priors" class="section h-100">
          <h4 class="section-header dotted-underline">Priors</h4>
          <div class="overflow-auto">
            <table id="table-priors" aria-label="Approved Regions for Scanning">
              <thead>
                <th>Modality</th>
                <th>Body Part/Procedure</th>
                <th>Prior Date</th>
              </thead>
              <tbody>
                <tr *ngFor="let prior of priors">
                  <td>{{ prior.modality }}</td>
                  <td>{{ prior.bodyPart }}</td>
                  <td>
                    {{ CommonUtilities.formatDateTime(prior.date) }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="row no-gutters panel-row mb-3">
      <div class="col">
        <mat-tab-group
          class="full-height-tab-content tab-header-bottom-border tab-header-round-top"
          [ngClass]="{ 'hide-tabs': onlyOneTab }"
          animationDuration="0ms"
          mat-stretch-tabs="false"
        >
          <mat-tab
            label="Regions for Scanning"
            aria-label="Regions for Scanning"
            *ngIf="referralScanRequests?.length > 0"
          >
            <h4
              *ngIf="(orderRows$ | async).length === 0"
              id="section-regions-for-scanning"
              class="section-header"
            >
              Regions for Scanning
            </h4>
            <div class="overflow-auto">
              <table
                class="regions-for-scanning"
                id="table-regions-for-scanning"
                aria-label="requested regions for scanning"
              >
                <thead>
                  <th>Modality</th>
                  <th>Body Part/Procedure</th>
                  <th>Phase of Contrast</th>
                  <th
                    *ngIf="
                      (showScanRegionDecisionColumns$ | async) ||
                      (orderRows$ | async).length > 0
                    "
                  >
                    Scan Protocol Notes
                  </th>
                  <th
                    *ngIf="
                      (showScanRegionDecisionColumns$ | async) ||
                      (orderRows$ | async).length > 0
                    "
                    class="text-center"
                  >
                    Approved / Declined
                  </th>
                </thead>
                <tbody>
                  <tr *ngFor="let scanRegion of referralScanRequests">
                    <td>{{ scanRegion.modality }}</td>
                    <td>{{ scanRegion.bodyPart }}</td>
                    <td>{{ scanRegion.contrast ?? '-' }}</td>
                    <td
                      *ngIf="
                        (showScanRegionDecisionColumns$ | async) ||
                        (orderRows$ | async).length > 0
                      "
                    >
                      {{ scanRegion.scanNotes }}
                    </td>
                    <td
                      *ngIf="
                        (showScanRegionDecisionColumns$ | async) ||
                        (orderRows$ | async).length > 0
                      "
                    >
                      <p
                        class="{{
                          ScanRegionStatusClassMapping.get(scanRegion.status)
                        }} badge"
                      >
                        {{
                          (
                            ClassToDisplayMapping.get(
                              ScanRegionStatusClassMapping.get(
                                scanRegion.status
                              )
                            ) ?? 'Unknown'
                          ).toUpperCase()
                        }}
                      </p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </mat-tab>
          <mat-tab
            label="Order Details"
            aria-label="Order Details"
            *ngIf="(orderRows$ | async)?.length > 0"
          >
            <app-imaging-request-orders-details [orders]="orderRows$ | async">
            </app-imaging-request-orders-details>
          </mat-tab>
        </mat-tab-group>
      </div>
      <div class="col">
        <div id="section-notes-from-radiologist" class="section h-100">
          <h4 class="section-header dotted-underline">
            Notes from Radiologist
          </h4>
          <div class="row section-body pl-3" id="notes-from-radiologist">
            {{ latestDecisionReason$ | async }}
          </div>
        </div>
      </div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions
    class="justify-content-sm-end justify-content-center mr-1"
  >
    @if(showClinicalDiscussionToggle) {
    <div class="request-call-with-radiologist">
      <label class="request-call-label" for="toggle-input"
        >Call with Radiologist requested?</label
      >
      <app-toggle
        [toggleState]="(callRequested$ | async) ? 'Yes' : 'No'"
        toggleOffLabel="No"
        toggleOnLabel="Yes"
        disabled
      ></app-toggle>
    </div>
    }
    <button mat-stroked-button id="close" mat-dialog-close type="button">
      Close without Saving
    </button>
  </mat-dialog-actions>
</div>
<div
  *ngIf="hasPendingChanges$ | async"
  id="streaming-notification"
  class="floating-notification clickable alert"
  (click)="mergePendingChanges()"
>
  <fa-icon class="pr-2" [icon]="['fas', 'info-circle']"></fa-icon>
  Details of this request have been updated, please click here to refresh.
</div>
